import { LeadCaptureForm } from "./LeadCaptureForm";

export function Partnership({ content, language }) {
  return (
    <section id="contact" className="section partnership-section" data-slide="10" data-testid="partnership-section">
      <div className="partnership-panel partnership-lead-layout">
        <div className="partnership-copy">
          <p className="overline" data-testid="partnership-overline">{content.overline}</p>
          <h2 data-testid="partnership-title">{content.title}</h2>
          <p data-testid="partnership-description">
            {content.description}
          </p>
        </div>
        <LeadCaptureForm language={language} />
      </div>
    </section>
  );
}